(ns machtfit.dashboard.stepchall.form.name
  (:require [clojure.string :as str]
            [machtfit.dashboard-widgets :as widgets]
            [re-frame.core :as rf]))

(defn- name-variation [variation language placeholder]
  (let [path [:challenge :config :names variation language]
        value @(rf/subscribe [:get path])]
    [widgets/inline-input
     {:required? true
      :id (str "name-variation-" (name variation) "-" language)
      :value value
      :placeholder placeholder
      :on-change #(rf/dispatch [:set-path path %])
      :style {:width (str (max (if (str/blank? value)
                                 (count placeholder)
                                 5) (count value)) "ch")
              :font-family "monospace"
              :transition "none"
              :text-decoration "inherit"}}]))

(defn section-name []
  [widgets/section
   {:anchor "name"
    :title "Name"
    :content [:div
              [:div.col.s12
               [:p "Die folgenden Beispielsätze müssen grammatikalisch richtig mit dem Namen ergänzt werden, die Artikel sind wichtig."]]
              [:div.col.s12
               [:table.table.table-bordered
                [:thead
                 [:tr
                  [:th]
                  [:th "Deutsch"]
                  [:th "Englisch"]]]
                [:tbody
                 [:tr
                  [:td [:b "Titel" [:br] "(ohne Artikel)"]]
                  [:td [name-variation :challenge-name :de "Aktiv-Challenge"]]
                  [:td [name-variation :challenge-name :en "Activity Challenge"]]]
                 [:tr
                  [:td [:b "Nominativ" [:br] "(mit Artikel)"]]
                  [:td "Achtung, "
                   [name-variation :the-challenge :de "die Aktiv-Challenge"]
                   " läuft bereits."]
                  [:td "Heads up, "
                   [name-variation :the-challenge :en "the Activity Challenge"]
                   " is already underway."]]
                 [:tr
                  [:td [:b "Genitiv" [:br] "(mit Artikel)"]]
                  [:td "Noch ein Tag bis zum Start "
                   [:span {:style {:white-space "nowrap"}}
                    [name-variation :the-challenge-genitive :de "der Aktiv-Challenge"]
                    "."]]
                  [:td "One day until "
                   [name-variation :the-challenge-genitive :en "the Activity Challenge's"]
                   " start."]]
                 [:tr
                  [:td [:b "Dativ" [:br] "(bei/zu + Artikel)"]]
                  [:td "Herzlich willkommen "
                   [:span {:style {:white-space "nowrap"}}
                    [name-variation :to-the-challenge :de "zur Aktiv-Challenge"]
                    "."]]
                  [:td "Welcome "
                   [:span {:style {:white-space "nowrap"}}
                    [name-variation :to-the-challenge :en "to the Activity Challenge"]
                    "."]]]
                 [:tr
                  [:td [:b "Dativ" [:br] "(in + Artikel)"]]
                  [:td "Teams treten "
                   [name-variation :in-the-challenge :de "in der Aktiv-Challenge"]
                   " gegeneinander an."]
                  [:td "Teams compete against each other "
                   [:span {:style {:white-space "nowrap"}}
                    [name-variation :in-the-challenge :en "in the Activity Challenge"]
                    "."]]]
                 [:tr
                  [:td [:b "Akkusativ" [:br] "(mit Artikel)"]]
                  [:td "Du kannst "
                   [name-variation :the-challenge-accusative :de "die Aktiv-Challenge"]
                   " als Zuschauer verfolgen."]
                  [:td "You can follow "
                   [name-variation :the-challenge-accusative :en "the Activity Challenge"]
                   " as a spectator."]]]]]]}])
